import { render, staticRenderFns } from "./Func55ExtratoUtilizacao.vue?vue&type=template&id=6945181e&scoped=true"
import script from "./Func55ExtratoUtilizacao.vue?vue&type=script&lang=js"
export * from "./Func55ExtratoUtilizacao.vue?vue&type=script&lang=js"
import style0 from "./Func55ExtratoUtilizacao.vue?vue&type=style&index=0&id=6945181e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945181e",
  null
  
)

export default component.exports